import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import FontAwesome from 'react-fontawesome';

import './TopNavButton.css';

class TopNavButtonClass extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      buttonText: this.props.buttonText,
      linkto: this.props.linkto,
      confirmed: this.props.confirmed,
      active: this.props.active,
    };
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    this.setState({
      buttonText: newProps.buttonText,
      linkto: newProps.linkto,
      confirmed: newProps.confirmed,
      active: newProps.active,
    });
  }

  handleClick = () => {
    this.props.setCurrentTab(this.state.linkto);
    this.props.navigate(`/${this.state.linkto}`);
  };

  handleKeyPress = () => {
    this.props.setCurrentTab(this.state.linkto);
    this.props.navigate(`/${this.state.linkto}`);
  };

  render() {
    return (
      <div
        id={this.props.id}
        role="button"
        tabIndex={0}
        onClick={this.handleClick}
        onKeyPress={this.handleKeyPress}
        className={`col-xs-4 center top-nav-button ${this.state.active ? 'active' : ''}`}
      >
        <span>
          <FontAwesome name="exclamation" className={`not-confirmed ${this.state.confirmed ? 'hidden' : ''}`} />
&nbsp;
          {this.state.buttonText.toUpperCase()}
        </span>
      </div>
    );
  }
}

TopNavButtonClass.propTypes = {
  buttonText: PropTypes.string.isRequired,
  linkto: PropTypes.string.isRequired,
  confirmed: PropTypes.bool.isRequired,
  active: PropTypes.bool.isRequired,
  setCurrentTab: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  navigate: PropTypes.func.isRequired,
};

function TopNavButton(props) {
  const navigate = useNavigate();
  return <TopNavButtonClass {...props} navigate={navigate} />;
}

export default TopNavButton;
